import { Link, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

import Button from '@/components/Buttons/Button';
import GoLogo from '@/components/GoLogo';
import { SUPPORT_EMAIL } from '@/constants/constants';
import { spacing } from '@/constants/ui';
import { useAppDispatch } from '@/hooks/redux-hooks';
import { BaseLayout } from '@/layouts/BaseLayout';
import { CenteredLayout } from '@/layouts/CenteredLayout';
import { useGxTokenFromStorage, useTripTokenFromStorage } from '@/services/storage';
import { logout } from '@/slices/authSlice';

const NotFound = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const gxToken = useGxTokenFromStorage();
  const tripToken = useTripTokenFromStorage();
  const loggedIn = !!gxToken || !!tripToken;
  return (
    <BaseLayout>
      <CenteredLayout>
        <GoLogo size={74} />
        <Typography
          sx={{ textAlign: 'center', mt: spacing[4] }}
          variant='h1'
        >
          Oops! Something went wrong.
        </Typography>
        <Typography
          sx={{ my: spacing[2] }}
          variant='subtitle1'
        >
          Let's jump back in
        </Typography>

        <Button
          sx={{
            width: 250,
            mb: spacing[3]
          }}
          variant='contained'
          onClick={() => {
            if (!loggedIn) dispatch(logout());
            navigate(loggedIn ? '/markets' : '/login');
          }}
        >
          Go to {loggedIn ? 'Markets' : 'Login'}
        </Button>
        <Typography sx={{ textAlign: 'center' }}>
          Any issues? Drop us a line at{' '}
          <Link
            color='text.primary'
            href={`mailto:${SUPPORT_EMAIL}`}
            sx={{ whiteSpace: 'nowrap' }}
            target='_top'
          >
            {SUPPORT_EMAIL}
          </Link>
        </Typography>
      </CenteredLayout>
    </BaseLayout>
  );
};

export default NotFound;
